import React, { useState, useEffect } from 'react';
import { Form, required, SelectInput, TextInput, useGetIdentity } from 'react-admin';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';

import Solo from './Solo';
import Team from './Team';

import { fetchTimeEntriesStats } from '../../../../../services/api';
import { countWorkingDays } from '../../../../../services/utils';


const BattleTab = () => {
    const defaultMonth = moment().format('YYYY-MM');
    const [loading, setLoading] = useState(true);
    const [type, setType] = useState('solo');
    const [projectId, setProjectId] = useState();
    const [projectChoices, setProjectChoices] = useState([]);
    const [month, setMonth] = useState(defaultMonth);
    const [stats, setStats] = useState();
    const [workingDaysCount, setWorkingDaysCount] = useState();
    const { data: account } = useGetIdentity();

    useEffect(() => {
        const fetchStats = async () => {
            setLoading(true);
            const momentMonth = month ? moment(`${month}-01`) : moment();
            const startDate = momentMonth.startOf('month').format('YYYY-MM-DD');
            const endDate = momentMonth.endOf('month').format('YYYY-MM-DD');

            const filters = {
                user_id: account?.id,
                start_date: startDate,
                end_date: endDate,
                freq: 'monthly',
                group_by: 'project'
            };
            const newStats = await fetchTimeEntriesStats(filters);
            let data;

            if (newStats?.data?.length > 0) {
                const promises = newStats.data.map(async item => {
                    const response = await fetchTimeEntriesStats({ ...filters, project_id: item?.group_by_id, group_by: 'type' });
                    const types = response?.data?.sort((a, b) => b.value - a.value);
                    return { ...item, types };
                });
                data = await Promise.all(promises);
            }
            data = data?.sort((a, b) => b.value - a.value);
            setStats({ ...newStats, data });

            const newWorkingDaysCount = countWorkingDays(startDate, endDate)
            setWorkingDaysCount(newWorkingDaysCount);
            // TODO: remove leaves from working days?

            setLoading(false);
        }

        fetchStats();
    }, [month]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (type === 'team') {
            if (stats?.data?.length > 0) {
                const choices = stats?.data?.reduce((acc, item) => {
                    return [...acc, { id: item.group_by_id, name: item.name }];
                }, []);
                setProjectChoices(choices);
            }
            else {
                setProjectChoices([]);
            }
        }
    }, [type, stats]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleChangeMonth = (e) => {
        setMonth(e?.target?.value);
    };

    const handleChangeType = (e) => {
        setType(e?.target?.value);
    };

    const handleChangeProject = (e) => {
        setProjectId(e?.target?.value);
    };

    return (
        <Box mt={2}>
            <Form defaultValues={{ month: defaultMonth }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <Box sx={{ display: 'flex', gap: '5px' }}>
                        <SelectInput source="type" choices={[{ id: 'solo', name: 'Solo' }, { id: 'team', name: 'Team' }]} onChange={handleChangeType} defaultValue="solo" helperText={false} sx={{ margin: 0 }} validate={required()} />
                        {(type === 'team' && projectChoices?.length > 0) && (
                            <SelectInput source="project_id" choices={projectChoices} onChange={handleChangeProject} helperText={false} sx={{ margin: 0 }} validate={required()} />
                        )}
                    </Box>
                    <TextInput label={false} source="month" type="month" onChange={handleChangeMonth} helperText={false} />
                </Box>
            </Form>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
                    <CircularProgress size={60} thickness={8} />
                </Box>
            ) : (
                <>
                    {type === 'team' ? (
                        <Team stats={stats} month={month} projectId={projectId} />
                    ) : (
                        <Solo stats={stats} workingDaysCount={workingDaysCount} />
                    )}
                </>
            )}
        </Box>
    );
};

export default BattleTab;